interface User {
  id: number
  email: string
  name: string
}

export default function getUser(): User | null {
  const user = localStorage.getItem("user")
  if (user) {
    return JSON.parse(user) as User
  }
  return null
}
